module.exports = __webpack_public_path__ + "static/media/control-points-pic2.04afd792.svg";